// extracted by mini-css-extract-plugin
export default {"container":"sL7NO","content":"o25_v","additionalInfo":"bJ60s","divider":"kwV4Y"};